import { useState } from "react";
import ModalWrapper from "../UI/ModalWrapper";
import CriticalityBadge from "../CriticalityBadge";
import SearchBar from "../UI/Searchbar";
import { Icon } from "../UI/Icon";
import Selector from "./../UI/Selector"
import usePatch from "./../../Hooks/usePatch"
import API_ENDPOINTS from "../../Config/api";
import { toast } from 'react-toastify';
import ClipLoader from 'react-spinners/ClipLoader'

export default function SuperficieEsternaEspostaTable1({

  data,
  setData

}) {

  const [search, setSearch] = useState("");

  const filteredRows = (data?.results ?? []).filter((item) => {
    const matchText = (item.asset ?? "").toLowerCase().includes(search.toLowerCase());
    return matchText
  });

  return (
    <>
      <div className="mb-4">
        <SearchBar search={search} setSearch={setSearch} />
      </div>

      <div className="flex flex-col h-[500px] ">
        <div className="flex-1 min-h-0 overflow-y-auto [scrollbar-gutter:stable] border-[#D1D5DB] border rounded">
          <table className="w-full table-auto text-sm text-slate-200 border-collapse">
            <colgroup>
              <col className="w-[60%]" /> {/* Asset */}
              <col className="w-[10%]" /> {/* Nome vulnerabilità */}
              <col className="w-[10%]" /> {/* Rischio */}
              <col className="w-[5%]" />  {/* Data rilevamento */}
              <col className="w-[5%]" />  {/* Stato */}
              <col className="w-[5%]" /> {/* Descrizione */}
              <col className="w-[5%]" /> {/* Nota */}
            </colgroup>

            <thead className="text-black text-sm sticky top-0 z-10 bg-[#F3F4F7]">
              <tr>
                <th className="px-3 py-5 text-left font-medium whitespace-nowrap">Asset</th>
                <th className="px-3 py-5 text-center font-medium whitespace-nowrap">Nome vulnerabilità</th>
                <th className="px-3 py-5 text-center font-medium whitespace-nowrap">Rischio</th>
                <th className="px-3 py-5 text-center font-medium whitespace-nowrap">Data rilevamento</th>
                <th className="px-3 py-5 text-center font-medium whitespace-nowrap">Stato</th>
                <th className="px-3 py-5 text-center font-medium whitespace-nowrap">Descrizione</th>
                <th className="px-3 py-5 text-center font-medium whitespace-nowrap">Nota</th>
              </tr>
            </thead>


            <tbody>
              {filteredRows.length > 0 ? (
                filteredRows.map((item, i) => (
                  <Row
                    key={i}
                    item={item}
                    setData={setData}
                    data={data}
                  />
                ))
              ) : (
                <tr>
                  <td colSpan={7} className="text-center py-6 text-slate-400">
                    Nessun asset trovato
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
}

function Row({

  item,
  setData,
  data

}) {

  const STATUS_OPTIONS = [
    { value: "open", label: "Aperto" },
    { value: "managed", label: "Gestito" },
    { value: "resolved", label: "Risolto" },
    { value: "false_positive", label: "Falso positivo" },
  ];

  const [showDescriptionModal, setShowDescriptionModal] = useState(false);
  const [showNoteModal, setShowNoteModal] = useState(false);
  const [modalContent, setModalContent] = useState({});

  const [statusSelected, setStatusSelected] = useState(item.status)
  const [nota, setNota] = useState(item.status_note);
  const [prevNota, setPrevNota] = useState();

  const { patchData, loading } = usePatch()

  const handleOpenDescriptionModal = (obj) => {
    setModalContent({ vulnerabilita: obj.vulnerabilita, description: obj.descrizione });
    setShowDescriptionModal(true);
  };

  async function handleSaveStatus(valueSelector) {
    try {
      const res = await patchData(API_ENDPOINTS.changeStatusVulnerability(item.id),
        { status: valueSelector, }
      );
      setData(prev => {
        if (!prev?.results) return prev; // safety nel caso in cui prev sia undefined/null
        return {
          ...prev,
          results: prev.results.map(f =>
            f.id === item.id ? { ...f, status: valueSelector } : f
          ),
        };
      });
      setStatusSelected(valueSelector)
      toast.success("Stato aggiornato");
    } catch (err) {
      toast.error(`Errore aggiornamento stato: ${err?.message ?? "errore sconosciuto"}`);
    }
  }

  async function handleSaveStatusNote(prevNota) {


    try {
      const res = await patchData(API_ENDPOINTS.changeStatusVulnerability(item.id),
        { status_note: prevNota }
      );
      setData(prev => {
        if (!prev?.results) return prev; // safety nel caso in cui prev sia undefined/null
        return {
          ...prev,
          results: prev.results.map(f =>
            f.id === item.id ? { status_note: prevNota } : f
          ),
        };
      });
      setNota(prevNota)
      setShowNoteModal(false)
      toast.success("Stato aggiornato");
    } catch (err) {
      toast.error(`Errore aggiornamento stato: ${err?.message ?? "errore sconosciuto"}`);
    }
  }

  return (
    <>
      <tr className="text-black border-white border-b-4 bg-[#E3E3E3]">

        {/* Asset */}
        <td className="px-3 py-3">
          <p className="font-semibold leading-tight">
            {item.asset ?? "--"}
          </p>
        </td>

        {/* Nome vulnerabilità */}
        <td className="px-3 py-3 text-center tabular-nums">
          {item.vulnerabilita ?? "--"}
        </td>

        {/* Rischio */}
        <td className="px-3 py-3 flex justify-center tabular-nums">
          <CriticalityBadge livello={item.rischio} />
        </td>

        {/* Data rilevamento */}
        <td className="px-3 py-3 text-center tabular-nums">
          {item.data_rilevamento ?? "--"}
        </td>



        {/* Stato */}
        <td className="px-3 py-3 text-center tabular-nums">
          {loading && !showNoteModal?
            <ClipLoader size={15} />
            :
            <Selector
              options={STATUS_OPTIONS}
              value={statusSelected}
              onChange={handleSaveStatus}
              width="w-36"
              rightIcon={false}
            />
          }
        </td>

        {/* Descrizione */}
        <td className="px-3 py-3 text-center tabular-nums">
          <button className="hover:scale-105 duration-300" onClick={() => handleOpenDescriptionModal(item)}>
            <Icon name={"eye"} />
          </button>
        </td>

        {/* Nota */}
        <td className="px-3 py-3 text-center tabular-nums">
          <button className="hover:scale-105 duration-300" onClick={() => setShowNoteModal(true)}>
            <Icon name={"edit"} />
          </button>
        </td>
      </tr>

      <ModalWrapper position="center" isOpen={showDescriptionModal} onClose={() => setShowDescriptionModal(false)}>
        <div className="bg-[#F3F4F7] rounded-lg shadow-md p-6 min-w-[400px] max-w-lg mx-auto">
          <div className="flex gap-2 items-center mb-4">
            <p className="text-lg font-semibold">Vulnerabilità:</p>
            <p>{modalContent.vulnerabilita ?? "-"}</p>
          </div>
          <p className="text-sm text-gray-700 whitespace-pre-line">{modalContent.description || "-"}</p>
        </div>
      </ModalWrapper>

      <ModalWrapper position="center" isOpen={showNoteModal} onClose={() => setShowNoteModal(false)}>
        <div className="bg-[#F3F4F7] rounded-lg shadow-md p-6 w-[600px] mx-auto">
          <div className="flex flex-col gap-2 mb-4 mt-4">
            <p className="text-sm text-left font-semibold text-black">Nota</p>
            <textarea
              name=""
              id=""
              className="w-full min-h-[120px] rounded-md border border-gray-300 px-3 py-2 bg-white text-black placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-400 focus:border-blue-400 resize-y"
              placeholder="Aggiungi una nota..."
              value={nota}
              onChange={(e) => setPrevNota(e.target.value)}
            />
          </div>

          <div className="mt-2 flex items-center justify-end gap-2">
            <button
              type="button"
              className="px-3 py-2 rounded border border-gray-300 bg-white text-black hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-300"
              onClick={() => setShowNoteModal(false)}
            >
              Annulla
            </button>
            <button
              type="button"
              className="px-3 py-2 rounded bg-blue-500 text-white hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
              onClick={() => handleSaveStatusNote(prevNota)}
            >
              Salva
            </button>
          </div>
        </div>
      </ModalWrapper>


    </>
  );
}






